var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFacebook = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 8,
  height: 17,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#98918A",
  d: "M5.192 5.723V4.34q0-.312.029-.482a.9.9 0 0 1 .131-.337.54.54 0 0 1 .332-.229 2.4 2.4 0 0 1 .61-.063h1.383V.459H5.465q-1.92 0-2.76.912-.837.911-.837 2.685v1.667H.21v2.769h1.657v8.032h3.325V8.492h2.212l.293-2.769z"
})));
export default SvgFacebook;